export const NOTIFICATION_V1_INBOX = '/v1/notification/inbox'
export const NOTIFICATION_V1_UNREAD = '/v1/notification/inbox/unread-count'
export const NOTIFICATION_V1_READ = (recipientId: number | string) =>
  `/v1/notification/inbox/${recipientId}/read`
